// Added by Ben on 17-Jan-2025 --Start
function BackInStock_openModal() {
  const SelectAllDatesQty = document.getElementById("selectalldatesqty");
  //SelectAllDatesQty.textContent = "Select All Dates";
  if (SelectAllDatesQty) {
    SelectAllDatesQty.textContent = "Select All Dates";
  }

  const modal = document.getElementById("wcBackInStockFormModal");
  const body = document.body;

  if (modal) {
    modal.classList.add("active"); // Show modal
    body.classList.add("modal-open"); // Prevent background scrolling
  }
  modal.style.display = "block";

  // Open the modal and trigger the custom event
  modal.dispatchEvent(new Event("customShow"));

  document.body.classList.add("body-no-scroll");
}

function closeModal() {
  const modal = document.getElementById("wcBackInStockFormModal");
  const body = document.body;

  if (modal) {
    modal.classList.remove("active"); // Hide modal
    body.classList.remove("modal-open"); // Restore background scrolling
  }

  modal.style.display = "none";
  document.body.classList.remove("body-no-scroll");
}

//Function to clear form
function clearForm() {
  const form = document.getElementById("customForm");
  form.reset();

  const divSubmitErrorMisc = document.getElementById("divSubmitErrorMisc");
  divSubmitErrorMisc.style.display = "none";
  const divSubmitError = document.getElementById("divSubmitError");
  divSubmitError.style.display = "none";
  const divSubmitSuccess = document.getElementById("divSubmitSuccess");
  divSubmitSuccess.style.display = "none";
  const btnClose = document.getElementById("btnClose");
  btnClose.style.display = "none";
  const btnSubmit = document.getElementById("btnSubmit");
  btnSubmit.style.display = "inline";
}

// Create a wrapper function to call multiple functions
function callMultipleFunctions() {
  clearForm();
  fetchAllDates();
}

// Function to select and trigger the first radio button
function selectAndTriggerFirstRadioButton() {
  const firstRadioButton = document.querySelector(
    'input[name="variant_id"]:first-of-type'
  );

  if (firstRadioButton) {
    firstRadioButton.checked = true; // Select the radio button

    // Trigger the click event programmatically
    firstRadioButton.dispatchEvent(new Event("click"));
  } else {
    console.log("No radio buttons found to select.");
  }
}

/* Fetch all dates when modal form opens --Start */

let allData = [];
const radioButtons = document.querySelectorAll(".mpc-variant-radio");
const datesContainer = document.getElementById("not-available-dates");
const soldoutdateContainer = document.getElementById("soldoutdates");
datesContainer.style.display = "none"; // Hides the element
const dropdownToggle = document.getElementById("dropdownToggle");
const dropdownContent = document.getElementById("not-available-dates");

function fetchAllDates() {
  // datesContainer.innerHTML = "<p>Loading all data...</p>";
  // datesContainer.style.display = "none"; // Hides the element

  if (datesContainer) {
    datesContainer.innerHTML = "<p>Loading all data...</p>";
    datesContainer.style.display = "none"; // Hides the element
  }

  const productId = document.querySelector('input[name="product_id"]').value;
  const dataToPost = { product_id: [productId] };

  //fetch("https://modest-wright.38-132-102-30.plesk.page/api/product", {
  fetch("https://ancona.mypetchicken.com/api/product", {
    //added by Ben in 2024-09-16
    method: "POST",
    body: JSON.stringify(dataToPost),
    mode: "cors",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
  })
    .then((response) => response.json())
    .then((result) => {
      if (!Array.isArray(result.data)) {
        //console.error("Response data is not an array:", result.data);
        datesContainer.innerHTML = "<p>Invalid data format received.</p>";
        return;
      }

      // Store sorted data locally
      allData = result.data
        .sort((a, b) => a.sku - b.sku)
        .filter((item) => Number(item.qty) === 0);

      console.log("API Data: " + JSON.stringify(allData));
      
      // Automatically select and trigger the first radio button
      selectAndTriggerFirstRadioButton();
    })
    .catch((error) => {
      datesContainer.innerHTML =
        "<p>Error loading data. Please try again later.</p>";
    });
}

/* Display dates based on variant selection — Start */
document.addEventListener("DOMContentLoaded", function () {
  function filterDatesByVariant(variantId) {
    const addedDates = new Set();
    datesContainer.innerHTML = ""; // Clear existing content

    const filteredData = allData.filter(
      (item) => String(item.variant_id) === String(variantId)
    );

    if (filteredData.length > 0) {
      filteredData.forEach((item) => {
        const { date: tbl_dateVal, sku: tbl_skuVal, qty: tbl_qtyVal } = item;

        if (!addedDates.has(tbl_dateVal)) {
          addedDates.add(tbl_dateVal);
          const label = document.createElement("label");
          label.innerHTML = `<input type="checkbox" name="date" value="${tbl_dateVal}"> ${tbl_dateVal}`;
          datesContainer.appendChild(label);
        }
      });

      setTimeout(() => {
        if (!datesContainer.hasChildNodes()) {
          datesContainer.style.display = "none";
          const divSubmitErrorMisc =
            document.getElementById("divSubmitErrorMisc");
          divSubmitErrorMisc.style.display = "block";
          const spnSubmitErrorMiscInner = document.getElementById(
            "spnSubmitErrorMiscInner"
          );
          spnSubmitErrorMiscInner.innerHTML =
            "Timeout, please try again -No dates available.";

          //alert("Timeout, No dates were fetched for the selected variant.");
        }
      }, 500);
    } else {
      datesContainer.style.display = "none";
      const divSubmitErrorMisc = document.getElementById("divSubmitErrorMisc");
      divSubmitErrorMisc.style.display = "block";
      const spnSubmitErrorMiscInner = document.getElementById(
        "spnSubmitErrorMiscInner"
      );
      spnSubmitErrorMiscInner.innerHTML =
        "No dates available for the selected variant.";

      //alert("No dates available for the selected variant.");
    }
  }

  radioButtons.forEach(function (radio) {
    radio.addEventListener("click", function () {
      dropdownContent.classList.remove("open");
      datesContainer.style.display = "none"; // Unhides the element
      const selectedVariantId = this.value; // Get selected variant ID from radio button value
      filterDatesByVariant(selectedVariantId); // Filter dates locally
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  dropdownToggle.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the default form submission
    event.stopPropagation(); // Prevent event bubbling

    if (dropdownContent.classList.contains("open")) {
      dropdownContent.classList.remove("open");
      datesContainer.style.display = "none"; // Hide the element
    } else {
      dropdownContent.classList.add("open"); // Toggle the dropdown
      datesContainer.style.display = "block"; // Show the element
    }
  });
});

// Close modal when clicking outside of it
window.onclick = function (event) {
  const modal = document.getElementById("wcBackInStockFormModal");
  if (event.target === modal) {
    modal.style.display = "none";
  }
};

// Added by Ben on 17-Jan-2025 --End

// Added by Ben on 24-Jan-2025 --Start
const SelectAllDatesQty = document.getElementById("selectalldatesqty");

document.addEventListener("DOMContentLoaded", function () {
  SelectAllDatesQty.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the default form submission
    event.stopPropagation(); // Prevent event bubbling

    const checkboxes = datesContainer.querySelectorAll(
      "input[type='checkbox']"
    );
    if (SelectAllDatesQty.textContent.trim() === "Select All Dates") {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = true;
      });

      SelectAllDatesQty.textContent = "Clear All";
    } else {
      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          checkbox.checked = false;
        }
      });

      SelectAllDatesQty.textContent = "Select All Dates";
    }
  });
});

// Added by Ben on 24-Jan-2025 --End
